import React from 'react'

function Foundations() {
   return (
      <section className="cs-bg-secondary pb-2 pt-5 text-center">
         <div className="container pb-5 mb-3">
            <h2 className="section_heading_title mb-3 tech_title">
               Foundations of Our Success
            </h2>

            <p className="section_desc mb-5 founder-value-sub core-value-sub">
               Our team is the driving force behind every innovation. Their
               expertise, dedication, and forward-thinking approach transform
               challenges into opportunities, delivering exceptional results
               with every project.
            </p>
         </div>
         <div className="container founder">
            <div>
               <div className="d-inline-flex">
                  <div className="founder_bg">
                     <div className="founder_fg"></div>
                     <img
                        className="founder_img"
                        src="/assets/image/DiscoverPage/ceo.png"
                     />
                  </div>
               </div>
               <a
                  href="https://www.linkedin.com/in/brijesh-vadukia"
                  className="section_secondary_bg tech_icon d-flex align-items-center justify-content-center"
                  target="_blank"
               >
                  <svg
                     width="48"
                     height="49"
                     viewBox="0 0 48 49"
                     className="tech_svg"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <g clipPath="url(#clip0_2393_56092)">
                        <path
                           d="M24 48.4629C37.2548 48.4629 48 37.7177 48 24.4629C48 11.2081 37.2548 0.462891 24 0.462891C10.7452 0.462891 0 11.2081 0 24.4629C0 37.7177 10.7452 48.4629 24 48.4629Z"
                           fill="#1F473E"
                        />
                        <path
                           d="M34.5 12.4629H13.5C13.1022 12.4629 12.7206 12.6209 12.4393 12.9022C12.158 13.1835 12 13.5651 12 13.9629V34.9629C12 35.3607 12.158 35.7422 12.4393 36.0236C12.7206 36.3049 13.1022 36.4629 13.5 36.4629H34.5C34.8978 36.4629 35.2794 36.3049 35.5607 36.0236C35.842 35.7422 36 35.3607 36 34.9629V13.9629C36 13.5651 35.842 13.1835 35.5607 12.9022C35.2794 12.6209 34.8978 12.4629 34.5 12.4629ZM19.5 32.7129H15.75V21.4629H19.5V32.7129ZM17.625 19.9629C17.18 19.9629 16.745 19.8309 16.375 19.5837C16.005 19.3365 15.7166 18.9851 15.5463 18.5739C15.376 18.1628 15.3314 17.7104 15.4182 17.2739C15.505 16.8375 15.7193 16.4366 16.034 16.1219C16.3487 15.8072 16.7496 15.5929 17.186 15.5061C17.6225 15.4193 18.0749 15.4639 18.486 15.6342C18.8972 15.8045 19.2486 16.0928 19.4958 16.4629C19.743 16.8329 19.875 17.2679 19.875 17.7129C19.875 18.3096 19.6379 18.8819 19.216 19.3039C18.794 19.7258 18.2217 19.9629 17.625 19.9629ZM32.25 32.7129H28.5V25.2129C28.5 24.5904 27.66 24.0879 26.625 24.0879C25.125 24.0879 24.75 26.0904 24.75 26.7129V32.7129H21V21.4629H24.75V24.0879C24.75 22.2129 26.43 21.4629 28.5 21.4629C29.4946 21.4629 30.4484 21.858 31.1516 22.5612C31.8549 23.2645 32.25 24.2183 32.25 25.2129V32.7129Z"
                           fill="white"
                        />
                     </g>
                     <defs>
                        <clippath id="clip0_2393_56092">
                           <rect
                              width="48"
                              height="48"
                              fill="white"
                              transform="translate(0 0.462891)"
                           />
                        </clippath>
                     </defs>
                  </svg>
               </a>
               <div className="founder_detail">
                  <p className="founder_name">Brijesh Vadukia</p>
                  <p className="founder_sub_title">Founder & CEO</p>
                  <p className="founder_desc">
                     Being an ardent CEO and Startup Advisor, I juggle
                     leadership and family with a vision of excellence and
                     innovation to Benzatine Infotech. We are dedicated to
                     leading the way in pioneering cutting-edge technology
                     solutions that make operations seamless and drive
                     effortless execution. With our nimble style, we empower
                     businesses globally with efficiency and satisfaction. Our
                     absolute dedication to transparency and the fusion of smart
                     technologies makes us stand out in the constantly changing
                     IT world.
                  </p>
               </div>
            </div>
            <div>
               <div className="d-inline-flex second_user">
                  <div className="founder_bg">
                     <div className="founder_fg"></div>
                     <img
                        className="founder_img"
                        src="/assets/svg/discover/img-core-team-2_1.png"
                     />
                  </div>
               </div>
               <a
                  href="https://www.linkedin.com/in/chirag-vadukia-186483a0"
                  className="section_secondary_bg tech_icon d-flex align-items-center justify-content-center"
               >
                  <svg
                     width="48"
                     height="49"
                     viewBox="0 0 48 49"
                     className="tech_svg"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <g clipPath="url(#clip0_2393_56092)">
                        <path
                           d="M24 48.4629C37.2548 48.4629 48 37.7177 48 24.4629C48 11.2081 37.2548 0.462891 24 0.462891C10.7452 0.462891 0 11.2081 0 24.4629C0 37.7177 10.7452 48.4629 24 48.4629Z"
                           fill="#1F473E"
                        />
                        <path
                           d="M34.5 12.4629H13.5C13.1022 12.4629 12.7206 12.6209 12.4393 12.9022C12.158 13.1835 12 13.5651 12 13.9629V34.9629C12 35.3607 12.158 35.7422 12.4393 36.0236C12.7206 36.3049 13.1022 36.4629 13.5 36.4629H34.5C34.8978 36.4629 35.2794 36.3049 35.5607 36.0236C35.842 35.7422 36 35.3607 36 34.9629V13.9629C36 13.5651 35.842 13.1835 35.5607 12.9022C35.2794 12.6209 34.8978 12.4629 34.5 12.4629ZM19.5 32.7129H15.75V21.4629H19.5V32.7129ZM17.625 19.9629C17.18 19.9629 16.745 19.8309 16.375 19.5837C16.005 19.3365 15.7166 18.9851 15.5463 18.5739C15.376 18.1628 15.3314 17.7104 15.4182 17.2739C15.505 16.8375 15.7193 16.4366 16.034 16.1219C16.3487 15.8072 16.7496 15.5929 17.186 15.5061C17.6225 15.4193 18.0749 15.4639 18.486 15.6342C18.8972 15.8045 19.2486 16.0928 19.4958 16.4629C19.743 16.8329 19.875 17.2679 19.875 17.7129C19.875 18.3096 19.6379 18.8819 19.216 19.3039C18.794 19.7258 18.2217 19.9629 17.625 19.9629ZM32.25 32.7129H28.5V25.2129C28.5 24.5904 27.66 24.0879 26.625 24.0879C25.125 24.0879 24.75 26.0904 24.75 26.7129V32.7129H21V21.4629H24.75V24.0879C24.75 22.2129 26.43 21.4629 28.5 21.4629C29.4946 21.4629 30.4484 21.858 31.1516 22.5612C31.8549 23.2645 32.25 24.2183 32.25 25.2129V32.7129Z"
                           fill="white"
                        />
                     </g>
                     <defs>
                        <clippath id="clip0_2393_56092">
                           <rect
                              width="48"
                              height="48"
                              fill="white"
                              transform="translate(0 0.462891)"
                           />
                        </clippath>
                     </defs>
                  </svg>
               </a>
               <div className="founder_detail">
                  <p className="founder_name">Chirag Vadukia</p>
                  <p className="founder_sub_title">Chief Product Officer</p>
                  <p className="founder_desc">
                     Chirag, Benzatine Infotech’s CPO, has always loved building
                     stuff that makes life easier. From messing with apps as a
                     teen, he’s got a vision for products that rock the tech
                     world. His leadership’s all about sparking ideas and
                     getting it done, guiding the team to create solutions
                     everyone loves. Chirag’s drive keeps pushing boundaries,
                     making clients smile with every slick new feature.
                  </p>
               </div>
            </div>
         </div>
      </section>
   )
}

export default Foundations
